import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, scheduleDetailFeatureKey } from './schedule-detail.reducer';

export const scheduleDetailFeature = createFeatureSelector<State>(scheduleDetailFeatureKey);

export const getSchedule = createSelector(scheduleDetailFeature, (state) => {
   return state.schedule;
});

export const getScheduleCallState = createSelector(scheduleDetailFeature, (state) => {
   return state.callState;
});
